<template>
  <div>
    <div style="display: inline-block" class="q-mr-sm">
      {{
        data.props.row.rb_data == 0
          ? "Un-Triggered"
          : data.props.row.rb_data == 1
          ? "Trap 1 Triggered"
          : data.props.row.rb_data == 2
          ? "Trap 2 Triggered"
          : "Both Traps Triggered"
      }}
    </div>
  </div>
</template>

<script>
  export default {
    props: ["data"],
    data: () => ({}),
  };
</script>
